import { render, staticRenderFns } from "./VersionMessage.vue?vue&type=template&id=304dd46e&scoped=true"
import script from "./VersionMessage.vue?vue&type=script&lang=js"
export * from "./VersionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304dd46e",
  null
  
)

export default component.exports